import { format } from 'date-fns-jalali'
const date = function (value: string|Date, date_format?: string) {
	return value?typeof value=='string'?format(new Date(value), date_format||'yy-MM-dd'):format(value, date_format||'yy-MM-dd'):'';
}
export default date;